import { LicenseManager } from "ag-grid-enterprise";

/**
 * AG Grid Enterprise License
 * Set VITE_AG_GRID_LICENSE_KEY in your .env file.
 * Contact your AG Grid account manager for the license key.
 */
export function registerAgGridLicense() {
  const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;
  if (licenseKey) {
    LicenseManager.setLicenseKey(licenseKey);
  } else {
    console.warn(
      "[AG Grid] No license key found. Set VITE_AG_GRID_LICENSE_KEY in .env. " +
      "Enterprise features will show a watermark in development."
    );
  }
}
